import { InjectionToken } from '@angular/core';

export const PLACEHOLDER_IMAGE_IMAGE = new InjectionToken<string>('PlaceholderImageUrl');
